import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Camera, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { uploadCertificate } from "../../api/payroll";
import { fileUrlAuth } from "../../api/fileUrl";
import { useApiError } from "../../hooks/useApiError";

// Lets employees snap or pick the hospital certificate from their phone.
export const CertificateUpload = ({ value, onChange }) => {
  const { t } = useTranslation();
  const describe = useApiError();
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const res = await uploadCertificate(file);
      onChange(res.url);
      toast.success(t("leaves.certificateUploaded"));
    } catch (error) {
      toast.error(describe(error));
    } finally {
      setBusy(false);
      event.target.value = "";
    }
  };

  return (
    <div>
      <p className="label-xs mb-2">{t("leaves.certificate")}</p>
      <input
        ref={input}
        type="file"
        accept="image/*,application/pdf"
        capture="environment"
        className="hidden"
        data-testid="certificate-input"
        onChange={pick}
      />
      <button
        type="button"
        data-testid="certificate-upload"
        disabled={busy}
        onClick={() => input.current?.click()}
        className={`flex w-full items-center justify-center gap-2 rounded-2xl px-4 py-3 text-sm font-bold shadow-neu-sm transition-[box-shadow] duration-300 hover:shadow-neu-in ${
          value ? "text-primary" : "text-muted-foreground"
        }`}
      >
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : value ? <Check className="h-4 w-4" /> : <Camera className="h-4 w-4" />}
        {value ? t("leaves.certificateReady") : t("leaves.certificatePick")}
      </button>
      {value ? (
        <a
          href={fileUrlAuth(value)}
          target="_blank"
          rel="noreferrer"
          data-testid="certificate-preview"
          className="mt-2 block text-center text-xs font-bold text-primary underline"
        >
          {t("leaves.certificateView")}
        </a>
      ) : (
        <p className="mt-1 text-xs text-amber-500">{t("leaves.certificateHint")}</p>
      )}
    </div>
  );
};
